//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import React, { useMemo } from 'react';
import styled, { keyframes } from 'styled-components';

//  -- Constants ----------------------
import COLOR from 'utils/constants/color';


//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
export const Wrapper = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
    padding: 2px 0px;
`;

const smoothSpin = keyframes`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`;

const SpinnerSvg = styled.svg`
    animation: ${smoothSpin} 1.1s linear infinite;
    transform-origin: center;
    transform: translateZ(0);
    will-change: transform;
`;


//  ----------------------------------------------------------------------------
//  Component
//  ----------------------------------------------------------------------------
//
//  Logo
//
//  -- Description
//  Experimental app logo
//
//  -- Props
//  size: number - The size of the loading spinner (default: 32)
//  white: bool - Whether to use white color instead of green
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//  ...
//
const Loading = ({ size = 32, white, ...props }) => {
    const fillColors = useMemo(() => ({
        primary: white ? COLOR.white : COLOR.green100,
        secondary: white ? COLOR.white : COLOR.green500,
        tertiary: white ? COLOR.white : COLOR.green900,
    }), [white]);

    return (
        <Wrapper {...props}>
            <SpinnerSvg height={size} x="0px" y="0px" viewBox="0 0 100 100" enableBackground="new 0 0 100 100">
                <path fill={fillColors.primary} d="M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3
                c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z" />
                <path fill={fillColors.secondary} d="M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7
                c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z" />
                <path fill={fillColors.tertiary} d="M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5
                L82,35.7z" />
            </SpinnerSvg>
        </Wrapper>
    );
};

export default React.memo(Loading);
